// Generado por scripts/i18n_generar.py (español → inglés)
export const ES_EN = {
 "Notas de la ubicación": "Location notes",
 "Visibles para el chofer antes de llegar.": "Visible to the driver before arrival.",
 "No se puede cambiar el tipo de operación: el viaje ya empezó": "The operation type cannot be changed after the trip has started",
 "Todas las fechas": "All dates",
 "Estados de todas las fechas": "Load status across all dates",
 "No hay cargas con estos filtros": "No loads match these filters",
 "Dónde se recoge el contenedor vacío": "Empty container pickup location",
 "Pickup location (donde se carga)": "Pickup location (where it is loaded)",
 "Dónde se devuelve el contenedor cargado": "Loaded container return location",
 "Ej.: Booking #5478": "E.g.: Booking #5478",
 "Ej.: PU-1042": "E.g.: PU-1042",
 "Elige el tamaño del contenedor (20, 40, 40HC, 45 o 53)": "Select the container size (20, 40, 40HC, 45 or 53)",
 "Carga la fecha del Empty Container Pickup": "Enter the Empty Container Pickup date",
 "En una exportación el chofer informa el número y la foto del contenedor en el paso 2 (Empty Container Pickup).": "For exports, the driver reports the container number and photo at step 2 (Empty Container Pickup).",
 "Las notas de la ubicación son demasiado largas (máximo {n} caracteres)": "Location notes are too long (maximum {n} characters)",
 "En ruta a recoger el contenedor vacío": "On the way to pick up the empty container",
 "En ruta al lugar de carga": "On the way to the pickup location",
 "En ruta a devolver el contenedor cargado": "On the way to return the loaded container",
 "Recogiendo el contenedor vacío": "Picking up the empty container",
 "En el lugar de carga": "At the pickup location",
 "Devolviendo el contenedor cargado": "Returning the loaded container",
 "Recoger el contenedor vacío": "Pick up the empty container",
 "Cargar en el lugar de recogida": "Load at the pickup location",
 "Devolver el contenedor cargado": "Return the loaded container",
 "$/Galón": "$/Gallon",
 "(desde la oficina)": "(from the office)",
 "(legibilidad {v0} de 5)": "(legibility {v0} out of 5)",
 "+ Nuevo cliente": "+ New customer",
 "1 carga": "1 load",
 "1 chofer en el recorrido": "1 driver on the route",
 "1. La plantilla": "1. The template",
 "2. Subir el archivo": "2. Upload the file",
 "20, 40 o 40HC. El chofer lo ve en su resumen del viaje.": "20, 40, or 40HC. The driver sees it in their trip recap.",
 "4 letras y 7 números. Debajo se ve como en el contenedor y te avisa si ya se cargó en los últimos 30 días.": "4 letters and 7 numbers. Below, it appears as it does on the container and lets you know if it was already entered in the last 30 days.",
 "A destinatarios": "To recipients",
 "A la izquierda están todas las secciones, agrupadas por tema. La que tiene la marca dorada es en la que estás.": "On the left are all the sections, grouped by topic. The one with the gold mark is the one you're in.",
 "A qué hora empezó y cerró el día cada chofer, y qué documentos avisó que no pudo subir.": "What time each driver started and closed the day, and which documents they reported they couldn't upload.",
 "ADMINISTRACIÓN": "ADMINISTRATION",
 "Accidente": "Accident",
 "Acciones": "Actions",
 "Activa": "Active",
 "Activar parada en yarda": "Activate yard stop",
 "Activo": "Active",
 "Actualizado hace {v0} s": "Updated {v0} sec ago",
 "Actívala si el recorrido pasa por una yarda. El chofer carga el espacio donde deja el equipo.": "Turn it on if the route goes through a yard. The driver enters the spot where the equipment is left.",
 "Adjunta el Delivery Order (el chofer lo abre desde su resumen del viaje) u otros papeles, PDF o foto. También se pueden agregar después.": "Attach the Delivery Order (the driver opens it from their Trip Recap) or other papers, PDF, or photo. You can also add them later.",
 "Adjuntar": "Attach",
 "Administrador": "Administrator",
 "Agente": "Assistant",
 "Agrega un cliente para elegirlo al cargar una orden.": "Add a customer so you can select it when entering an order.",
 "Agregar": "Add",
 "Ahora no": "Not now",
 "Alertas": "Alerts",
 "Alquiler de chasis": "Chassis rental",
 "Anterior": "Previous",
 "Antes de guardar, te muestra qué filas están bien y cuáles tienen errores.": "Before saving, it shows you which rows are correct and which ones have errors.",
 "Apagado — no envía nada": "Off — it doesn't send anything",
 "App del chofer · actualizaciones recibidas": "Driver app · updates received",
 "Aprobado": "Approved",
 "Aprobar": "Approve",
 "Aprobar o rechazar": "Approve or reject",
 "Arma el PDF, que aparece abajo en la lista.": "Build the PDF, which appears below in the list.",
 "Arrastra archivos aquí o toca para adjuntar": "Drag files here or tap to attach",
 "Asignada": "Assigned",
 "Asignadas": "Assigned",
 "Asignar todas a": "Assign all to",
 "Aviso de problema": "Problem notice",
 "Bienvenido a Leonas Group": "Welcome to Leonas Group",
 "Buscar": "Search",
 "Buscar cliente…": "Search customer…",
 "Buscar por contenedor o ID de carga": "Search by container or Load ID",
 "Buscar ubicación…": "Search location…",
 "Buscar una carga": "Search for a load",
 "CATÁLOGOS": "CATALOGS",
 "Cada archivo queda con su etapa, su chofer y la fecha y hora de subida. Los documentos tardíos no cambian las horas del movimiento.": "Each file keeps its step, driver, and upload date and time. Late documents do not change the movement times.",
 "Cada carga con su ID, contenedor y tamaño, tipo (azul importación, naranja exportación), estado y etapa en curso, chofer, cliente, ETA y documentos. Tócala para ver todo el detalle.": "Each load with its ID, container and size, type (blue import, orange export), status and current step, driver, customer, ETA, and documents. Tap it to see all the details.",
 "Cada contenedor, en su lugar.": "Every container in its place.",
 "Cada etapa lleva su propio chofer. Toca una etapa para ver y editar sus datos.": "Each step has its own driver. Tap a step to view and edit its details.",
 "Cada etapa muestra lo que cargó la oficina y, en verde, lo que reportó el chofer desde la app: llegada, salida, chassis, contenedor y ETA. Eso no se edita. Puedes cambiar el chofer, el lugar o la fecha de una etapa y tocar «Guardar cambios».": "Each step shows what the office entered and, in green, what the driver reported from the app: arrival, departure, chassis, container, and ETA. That can't be edited. You can change the driver, place, or date of a step and tap «Save changes».",
 "Cada recibo con su foto. «Corregido» quiere decir que el chofer cambió algo de lo que leyó la IA. Con el lápiz lo puedes editar.": "Each receipt with its photo. «Corrected» means the driver changed something from what the AI read. You can edit it with the pencil icon.",
 "Calle": "Street",
 "Calle y número": "Street and number",
 "Cambia el ID de carga, el contenedor, el tipo, el tamaño, el cliente o las notas.": "Change the Load ID, container, type, size, customer, or notes.",
 "Cambia tu contraseña": "Change your password",
 "Cambiar contraseña": "Change password",
 "Cambiar de día": "Change day",
 "Cambios guardados": "Changes saved",
 "Cambios sin guardar": "Unsaved changes",
 "Camión": "Truck",
 "Cancelada": "Cancelled",
 "Cancelar": "Cancel",
 "Cancelar carga": "Cancel load",
 "Carga": "Load",
 "Carga anterior al sistema de etapas": "Load created before the step system",
 "Carga cancelada": "Cancelled load",
 "Carga creada": "Load created",
 "Carga el ID, el contenedor y las etapas del recorrido. Cada etapa puede llevar un chofer distinto.": "Enter the Load ID, container, and trip steps. Each step can have a different driver.",
 "Carga la fecha del Rail pickup": "Enter the Rail pickup date",
 "Carga reactivada": "Load reactivated",
 "Carga {titulo}": "Load {titulo}",
 "Cargar una orden": "Upload an order",
 "Cargas": "Loads",
 "Cargas por reasignar": "Loads to reassign",
 "Cargas que un chofer no pudo terminar. Asígnalas a otro chofer.": "Loads a driver couldn't finish. Assign them to another driver.",
 "Cargas, choferes y papeles de Leonas Group en una sola plataforma.": "Loads, drivers, and paperwork from Leonas Group in one platform.",
 "Cargas, diésel, jornadas, problemas o insumos.": "Loads, fuel, shifts, issues, or supplies.",
 "Categoría": "Category",
 "Categoría actualizada": "Category updated",
 "Categoría creada": "Category created",
 "Categorías de gastos": "Expense categories",
 "Categorías de insumos y gastos": "Supply and expense categories",
 "Celular roto": "Broken phone",
 "Cerrada": "Closed",
 "Cerrar": "Close",
 "Cerrar la guía": "Close the guide",
 "Cerrar sesión": "Sign out",
 "Chassis devuelto": "Chassis returned",
 "Chassis reportado": "Reported chassis",
 "Chofer": "Driver",
 "Chofer (la etapa ya está completada)": "Driver (the step is already completed)",
 "Chofer de esta etapa": "Driver for this step",
 "Chofer responsable": "Responsible driver",
 "Chofer · {v0}": "Driver · {v0}",
 "Choferes": "Drivers",
 "Choferes, clientes o ubicaciones, desde un archivo de Excel o CSV.": "Drivers, customers, or locations, from an Excel or CSV file.",
 "Cierre": "End",
 "Cierre administrativo": "Administrative closure",
 "Cita (fecha)": "Appointment (date)",
 "Cita (hora)": "Appointment (time)",
 "Cita abierta: Desde y Hasta de la ventana (ej. 9:00 a 16:00). Cita fija: la misma hora en los dos.": "Open appointment: From and To of the window (e.g. 9:00 to 16:00). Fixed appointment: the same time in both.",
 "Cita y receiver": "Appointment and receiver",
 "Ciudad": "City",
 "Cliente": "Customer",
 "Cliente *": "Customer *",
 "Cliente actualizado": "Customer updated",
 "Cliente cerrado": "Closed customer",
 "Cliente creado": "Customer created",
 "Cliente frecuente": "Frequent customer",
 "Cliente · Riel": "Customer · Rail",
 "Cliente:": "Customer:",
 "Clientes": "Customers",
 "Clientes y ubicaciones": "Customers and locations",
 "Coincide": "Matches",
 "Completa de arriba hacia abajo. Lo que tiene * es obligatorio. Una carga es un viaje de etapas, cada una con su chofer.": "Fill it out from top to bottom. Fields marked with * are required. A load is a trip made up of steps, each with its own driver.",
 "Completada": "Completed",
 "Con el lápiz editas los datos. Con la llave le das una contraseña nueva.": "Use the pencil to edit the info. Use the key to assign a new password.",
 "Con el lápiz la editas o la desactivas.": "Use the pencil to edit it or deactivate it.",
 "Con el lápiz lo editas. Los frecuentes salen primero y los inactivos dejan de aparecer al cargar órdenes.": "Use the pencil to edit it. Frequent ones appear first, and inactive ones stop showing up when creating orders.",
 "Con las flechas o el calendario ves las cargas de otro día.": "Use the arrows or the calendar to view loads from another day.",
 "Con observaciones": "With notes",
 "Con problema": "Problem",
 "Configuración": "Settings",
 "Configuración de WhatsApp": "WhatsApp settings",
 "Configuración de WhatsApp guardada": "WhatsApp settings saved",
 "Configuración guardada": "Settings saved",
 "Confirmar importación ({validas})": "Confirm import ({validas})",
 "Contenedor": "Container",
 "Contenedor asignado *": "Assigned container *",
 "Contenedor asignado:": "Assigned container:",
 "Contenedor no coincide:": "Container does not match:",
 "Contenedor reportado": "Reported container",
 "Contesta preguntas sobre cargas, choferes, diésel, problemas e insumos con los datos de la plataforma. Solo consulta: no cambia nada.": "Answer questions about loads, drivers, fuel, issues, and supplies using platform data. Read-only: it doesn't change anything.",
 "Contraseña": "Password",
 "Contraseña actual": "Current password",
 "Contraseña actualizada": "Password updated",
 "Contraseña de {nombre} actualizada": "{nombre}'s password updated",
 "Contraseña inicial *": "Initial password *",
 "Corregido por el chofer": "Corrected by the driver",
 "Corregir recibo": "Correct receipt",
 "Correo conectado (Resend)": "Email connected (Resend)",
 "Correo de prueba enviado a {length} destinatario(s)": "Test email sent to {length} recipient(s)",
 "Correo enviado a {email}": "Email sent to {email}",
 "Correo inválido": "Invalid email",
 "Correo no configurado": "Email not configured",
 "Correos": "Emails",
 "Correos guardados": "Saved emails",
 "Crea los usuarios de choferes, dispatch y mantenimiento.": "Create driver, dispatch, and maintenance users.",
 "Crear": "Create",
 "Credenciales de Meta configuradas": "Meta credentials configured",
 "Cuando quieras, toca «Guía» en cualquier pantalla y te explica esa pantalla.": "Whenever you want, tap «Guide» on any screen and it explains that screen.",
 "Cuántas cargas hay sin asignar, asignadas, en ruta y terminadas, y tres avisos: con problema, por reasignar y con documentos pendientes. Toca uno para ver solo esas cargas; tócalo otra vez para ver todas.": "How many loads are unassigned, assigned, in transit, and finished, plus three alerts: problem, to reassign, and documents pending. Tap one to see only those loads; tap it again to see all of them.",
 "Datos de la carga": "Load details",
 "Delivery ETA vigente": "Current Delivery ETA",
 "Delivery Order, instrucciones u otros archivos para el chofer. Se pueden agregar después en el expediente.": "Delivery Order, instructions, or other files for the driver. They can be added later in the file.",
 "Depósito de vacíos": "Empty depot",
 "Descarga el archivo de ejemplo y complétalo.": "Download the sample file and fill it out.",
 "Descarga en un PDF las fotos del Signed DO / POD.": "Download the Signed DO / POD photos in a PDF.",
 "Descarga los recibos del período en un archivo para Excel.": "Download the receipts for the period in an Excel file.",
 "Descarga terminada": "Download complete",
 "Descargar": "Download",
 "Descargar PDF": "Download PDF",
 "Descargar plantilla": "Download template",
 "Descárgalo, mándalo a los destinatarios configurados o a otro correo.": "Download it, send it to the configured recipients, or to another email.",
 "Desde": "From",
 "Despachada": "Dispatched",
 "Destinatarios": "Recipients",
 "Detalle": "Detail",
 "Detalle de la carga": "Load detail",
 "Dirección": "Address",
 "Diésel": "Fuel",
 "Documento adjuntado": "Document attached",
 "Documentos": "Documents",
 "Documentos completos": "Complete documents",
 "Documentos de la oficina (el chofer los ve en su app)": "Documents from the office (the driver sees them in the app)",
 "Documentos por etapa e historial": "Documents by step and history",
 "Duplicado": "Duplicate",
 "Día anterior": "Previous day",
 "Día siguiente": "Next day",
 "Días": "Days",
 "Días (nota)": "Days",
 "Dónde se devuelve el chassis": "Where the chassis is returned",
 "Dónde se devuelve el vacío": "Where the empty container is returned",
 "EXPORTACIÓN": "EXPORT",
 "Edita los campos que estén mal leídos y guarda para registrar la corrección.": "Edit the fields that were read incorrectly and save to record the correction.",
 "Editar categoría": "Edit category",
 "Editar cliente": "Edit customer",
 "Editar datos de la carga": "Edit load details",
 "Editar los datos": "Edit the information",
 "Editar o cambiar la contraseña": "Edit or change the password",
 "Editar ubicación": "Edit location",
 "Editar usuario": "Edit user",
 "Ej.: Chassis reservation": "Ex.: Chassis reservation",
 "Ej.: DEL-1042": "Ex.: DEL-1042",
 "Ej.: Empty return reference": "Ex.: Empty return reference",
 "Ej.: LG-1042": "Ex.: LG-1042",
 "Ej.: Release #5478": "Ex.: Release #5478",
 "Ej.: dejar el equipo en la yarda": "Ex.: leave the equipment at the yard",
 "Ej.: lun–vie": "Ex.: Mon–Fri",
 "Ej.: número de chassis": "Ex.: chassis number",
 "Ej: Unidad 3": "Ex: Unit 3",
 "Ejecutar avisos de pendientes ahora": "Run pending alerts now",
 "Ejecutar recordatorios ahora": "Run reminders now",
 "Ejemplos": "Examples",
 "El ZIP debe tener 5 dígitos": "ZIP must have 5 digits",
 "El agente": "The assistant",
 "El documento que un chofer avisó que no pudo subir al cerrar el día (por ejemplo el Signed DO / POD), con el motivo. Sigue pendiente hasta que llegue.": "The document a driver reported they couldn't upload when closing the day (for example, the Signed DO / POD), along with the reason. It stays pending until it arrives.",
 "El día de cada chofer": "Each driver's day",
 "El escáner de papeles y las categorías de gastos.": "The paper scanner and expense categories.",
 "El identificador de la carga. No se puede repetir: si ya existe, la plataforma avisa.": "The Load ID. It can't be repeated: if it already exists, the platform alerts you.",
 "El menú": "The menu",
 "El modo \"real\" puede enviar mensajes por WhatsApp.": "\"Real\" mode can send messages through WhatsApp.",
 "El motivo es obligatorio": "Reason is required",
 "El recordatorio del turno y el aviso de papeles pendientes para los choferes.": "The shift reminder and pending paperwork notice for drivers.",
 "Elegir archivo (.csv / .xlsx)": "Choose file (.csv / .xlsx)",
 "Elegir chofer": "Choose driver",
 "Elegir cliente": "Choose customer",
 "Elige el día": "Choose the day",
 "Elige el rango de fechas": "Choose the date range",
 "Elige el tamaño del contenedor (20, 40 o 40HC)": "Choose the container size (20, 40, or 40HC)",
 "Elige el tipo de operación": "Choose the operation type",
 "Elige las fechas o usa los atajos: semana, mes o trimestre.": "Choose the dates or use shortcuts: week, month, or quarter.",
 "Elige las fechas o usa «Este trimestre» para la declaración trimestral.": "Choose the dates or use «This quarter» for the quarterly report.",
 "Elige quién recibe cada correo de la plataforma.": "Choose who receives each platform email.",
 "Elige un chofer para todas las etapas de una vez. Después puedes cambiar el chofer de una etapa en particular.": "Choose one driver for all steps at once. You can later change the driver for a specific step.",
 "Elige un cliente": "Choose a customer",
 "Elígelo de la lista. Si el cliente es nuevo, agrégalo con «+ Nuevo».": "Choose it from the list. If the customer is new, add it with «+ New».",
 "En Delivery la cita es la fecha y el horario Desde–Hasta (abierta, o fija con la misma hora en los dos). Elige también la zona horaria del receiver (el chofer pone la ETA en esa hora) y si es Live unload o Drop.": "In Delivery, the appointment is the date and the From–To time window (open, or fixed with the same time in both). Also choose the receiver time zone (the driver enters the ETA in that time) and whether it is Live unload or Drop.",
 "En curso": "In progress",
 "En el lugar": "On site",
 "En qué etapa está la carga.": "Which step the load is in.",
 "En ruta": "In transit",
 "Encuentra un cliente por su nombre.": "Find a customer by name.",
 "Encuentra una ubicación por su nombre.": "Find a location by name.",
 "Entrar": "Sign in",
 "Entregada": "Delivered",
 "Entregada al cliente": "Delivered to the customer",
 "Entregado": "Delivered",
 "Enviado": "Sent",
 "Enviado a {v0}": "Sent to {v0}",
 "Enviados {v0} · Simulados {v1} · Omitidos {v2} · Errores {v3}": "Sent {v0} · Simulated {v1} · Skipped {v2} · Errors {v3}",
 "Enviando": "Sending",
 "Enviar": "Send",
 "Enviar correo de prueba": "Send test email",
 "Enviar por correo": "Send by email",
 "Enviar prueba": "Send test",
 "Enviar resumen de hoy": "Send today's summary",
 "Es una yarda propia (Leona's yard)": "It's a company yard (Leona's yard)",
 "Escanear papel firmado": "Scan signed paperwork",
 "Escribe el ID de carga": "Enter the Load ID",
 "Escribe el motivo del rechazo. El chofer lo verá en su lista.": "Enter the reason for rejection. The Driver will see it in their list.",
 "Escribe el número de contenedor": "Enter the Container number",
 "Escribe el número de contenedor o el ID de la carga y la encuentra en cualquier fecha.": "Enter the Container number or Load ID to find it on any date.",
 "Escribe la nueva contraseña. El usuario deberá cambiarla al ingresar.": "Enter the new password. The user will have to change it when signing in.",
 "Escribe tu contraseña actual y elige una nueva.": "Enter your current password and choose a new one.",
 "Escribe tu contraseña actual.": "Enter your current password.",
 "Escribe un teléfono": "Enter a phone number",
 "Escribe una nota de rechazo": "Enter a rejection note",
 "Escríbela en palabras normales. Por ejemplo: «¿Qué choferes no subieron el papel hoy?» o «Mándame el reporte de diésel del trimestre».": "Write it in plain language. For example: «Which drivers didn’t upload the paperwork today?» or «Send me the quarterly fuel report».",
 "Escáner con IA, categorías de gasto, correos y WhatsApp": "Scanner with AI, expense categories, emails, and WhatsApp",
 "Escáner, categorías de gastos, correos y WhatsApp.": "Scanner, expense categories, emails, and WhatsApp.",
 "Espacio en la yarda": "Yard space",
 "Esta carga es anterior al sistema de etapas: elige el tamaño del contenedor (y, si quieres, un ID de carga) para poder guardar cambios.": "This load is from before the step system: choose the Container size (and, if you want, a Load ID) to save changes.",
 "Esta carga no tiene documentos de etapa.": "This load has no step documents.",
 "Esta guía": "This guide",
 "Esta semana": "This week",
 "Estación": "Station",
 "Estación / Ciudad": "Station / City",
 "Estado": "Status",
 "Estado del día": "Status of the day",
 "Este mes": "This month",
 "Este trimestre": "This quarter",
 "Etapa en curso": "Current step",
 "Etapas": "Steps",
 "Etapas del recorrido": "Trip steps",
 "Exportación": "Export",
 "Exportar": "Export",
 "Exportar CSV": "Export CSV",
 "Falla mecánica": "Mechanical failure",
 "Falta la API key de Resend (variable RESEND_API_KEY)": "Resend API key is missing (RESEND_API_KEY variable)",
 "Falta {v0} · {v1}{v2}": "Missing {v0} · {v1}{v2}",
 "Falta: {v0}": "Missing: {v0}",
 "Fecha": "Date",
 "Fecha *": "Date *",
 "Fecha y horario": "Date and time",
 "Fila": "Row",
 "Filtros": "Filters",
 "Firma": "Signature",
 "Formato poco común, ¿seguro?": "Uncommon format, are you sure?",
 "Foto": "Photo",
 "Foto del recibo": "Photo of the receipt",
 "Frecuente": "Frequent",
 "Fuera de horario": "After hours",
 "Galones": "Gallons",
 "Galones y monto de cada estado: lo que se necesita para el trimestral.": "Gallons and amount by state: what's needed for the quarterly report.",
 "Galones, monto y cantidad de recibos del período elegido.": "Gallons, amount, and number of receipts for the selected period.",
 "Gasto": "Expense",
 "Gasto aprobado": "Approved expense",
 "Gasto rechazado": "Rejected expense",
 "Gastos pendientes de aprobación": "Expenses pending approval",
 "Gastos por aprobar": "Expenses pending approval",
 "Gastos que no son habituales y esperan aprobación.": "Non-routine expenses pending approval.",
 "Genera reportes en PDF para descargar o enviar por correo": "Generate PDF reports to download or email",
 "Generado por {creado_por}{v1}": "Generated by {creado_por}{v1}",
 "Generar": "Generate",
 "Generar PDF": "Generate PDF",
 "Guarda la carga y aparece en el panel del día.": "Save the load and it appears on the Daily board.",
 "Guardar": "Save",
 "Guardar cambios": "Save changes",
 "Guardar carga": "Save load",
 "Guardar y continuar": "Save and continue",
 "Guía de la plataforma": "Platform guide",
 "HERRAMIENTAS": "TOOLS",
 "Habitual (no requiere aprobación)": "Usual (no approval needed)",
 "Habitual (sin aprobación)": "Routine (no approval)",
 "Hasta": "To",
 "Historial de ETA ({length})": "ETA history ({length})",
 "Historial de correcciones": "Correction history",
 "Historial de envíos": "Sent history",
 "Hola, {v0}": "Hi, {v0}",
 "Hora del aviso de papeles pendientes": "Time for pending paperwork alert",
 "Hora del recordatorio (mañana)": "Reminder time (tomorrow)",
 "Hora del resumen diario": "Daily summary time",
 "Hubo un error consultando al agente.": "There was an error checking with the assistant.",
 "Hubo un error consultando al agente. Prueba de nuevo.": "There was an error checking with the assistant. Try again.",
 "ID de carga": "Load ID",
 "ID de carga *": "Load ID *",
 "IMPORTACIÓN": "IMPORT",
 "Idioma de la plantilla (Meta)": "Template language (Meta)",
 "Idioma de los correos": "Email language",
 "Importación": "Import",
 "Importación (azul) o exportación (naranja).": "Import (blue) or export (orange).",
 "Importar": "Import",
 "Importar catálogos": "Import catalogs",
 "Inactiva": "Inactive",
 "Inactivo": "Inactive",
 "Incidente resuelto": "Incident resolved",
 "Incidentes": "Incidents",
 "Incidentes abiertos": "Open incidents",
 "Incluir fotos": "Include photos",
 "Ingresa un correo": "Enter an email",
 "Inicio": "Start",
 "Inicio, cierre y horas trabajadas. La barra muestra su día de 5 AM a 9 PM.": "Start, end, and hours worked. The bar shows your day from 5 AM to 9 PM.",
 "Instrucciones": "Instructions",
 "Instrucciones para el chofer": "Instructions for the driver",
 "Insumos": "Supplies",
 "Insumos y gastos": "Supplies and expenses",
 "Jornadas": "Shifts",
 "La carga": "The load",
 "La carga se cierra cuando terminan todas las etapas y llegan los documentos obligatorios: Signed DO / POD y Empty return J1. Si falta alguno, dice cuál.": "The load closes when all steps are finished and the required documents arrive: Signed DO / POD and Empty return J1. If any are missing, it shows which one.",
 "La carga se creó, pero no se pudieron subir los documentos: {v0}": "The load was created, but the documents could not be uploaded: {v0}",
 "La carga vuelve a su estado anterior a la cancelación, con el avance y los choferes que tenía en cada etapa.": "The load returns to its status before cancellation, with the progress and drivers it had in each step.",
 "La contraseña debe tener al menos 6 caracteres.": "Password must be at least 6 characters long.",
 "La etapa «{n}» necesita un lugar": "Step «{n}» needs a location",
 "La fecha del Rail pickup es obligatoria. La fecha y la hora de cada etapa son las que usa el recordatorio de WhatsApp del chofer.": "The Rail pickup date is required. The date and time of each step are what the driver's WhatsApp reminder uses.",
 "La lista": "The list",
 "La prueba y el resumen se mandan a los destinatarios guardados.": "The test and the summary are sent to the saved recipients.",
 "Las cargas": "The loads",
 "Las categorías \"habituales\" no requieren aprobación para registrar un gasto.": "Regular categories don't need approval to log an expense.",
 "Las contraseñas no coinciden.": "Passwords do not match.",
 "Las habituales, como aceite o limpiaparabrisas, se registran sin aprobación.": "Regular items, like oil or windshield washer fluid, are logged without approval.",
 "Las listas que se eligen al cargar una orden: clientes, rieles, yardas y depósitos.": "The lists selected when creating an order: customers, rails, yards, and depots.",
 "Legibilidad del papel": "Paper legibility",
 "Legibilidad {legibilidad}/5": "Legibility {legibilidad}/5",
 "Leyendo archivo…": "Reading file…",
 "Llanta": "Tire",
 "Llegada": "Arrival",
 "Lo que necesita atención de la oficina ahora": "What needs office attention right now",
 "Lo que piden los choferes y los gastos que hicieron, para entregar o aprobar.": "What drivers request and the expenses they made, to deliver or approve.",
 "Lo que piden los choferes. Márcalo como entregado cuando se lo des.": "What drivers request. Mark it as delivered when you give it to them.",
 "Lo que reportaron los choferes con el botón rojo. Toca «Resolver» cuando esté atendido.": "What drivers reported with the red button. Tap «Resolve» when it's handled.",
 "Lo que subió el chofer en cada etapa, con su hora real de subida, y los archivos de la oficina. Si falta un documento obligatorio, lo puedes adjuntar tú.": "What the driver uploaded at each step, with the actual upload time, and the office files. If a required document is missing, you can attach it yourself.",
 "Los correos salen desde": "Emails are sent from",
 "Los recibos de diésel que suben los choferes, con totales por estado para la declaración trimestral.": "The Fuel receipts drivers upload, with totals by state for the quarterly filing.",
 "Los Ángeles (PT)": "Los Angeles (PT)",
 "Lugar": "Place",
 "Línea de tiempo": "Timeline",
 "Mantenimiento": "Maintenance",
 "Marcado como entregado": "Marked as delivered",
 "Marcar resuelto": "Mark as resolved",
 "Mientras no estén, el modo \"real\" quedará sin efecto (los envíos se marcan como error). Usa \"simulación\" para probar el flujo sin credenciales.": "Until they are set, \"real\" mode will stay disabled (shipments are marked as error). Use \"simulation\" to test the flow without credentials.",
 "Modo": "Mode",
 "Monto": "Amount",
 "Motivo de la cancelación": "Cancellation reason",
 "Motivo del rechazo": "Rejection reason",
 "Motivo: {v0}": "Reason: {v0}",
 "Movida": "Moved",
 "Muestra las jornadas de los choferes de esa fecha.": "Shows the drivers' shifts for that date.",
 "Muestra solo las cargas de un estado o de un chofer (también las cargas donde ese chofer tiene alguna etapa).": "Shows only the loads for one status or one driver (also loads where that driver has a step).",
 "Nada pendiente": "Nothing pending",
 "No coincide con el asignado ({numero_contenedor})": "Doesn't match the assigned one ({numero_contenedor})",
 "No disponible": "Not available",
 "No hay cambios para guardar": "There are no changes to save",
 "No hay cargas para este día": "There are no loads for this day",
 "No hay jornadas para esta fecha": "There are no shifts for this date",
 "No hay recibos de diésel en este período": "There are no fuel receipts in this period",
 "No se pudo enviar": "Couldn't send",
 "Nombre": "Name",
 "Nombre *": "Name *",
 "Nombre de la etapa": "Step name",
 "Nota de resolución (opcional)": "Resolution note (optional)",
 "Nota: {nota}": "Note: {nota}",
 "Notas": "Notes",
 "Nueva": "New",
 "Nueva York (ET)": "New York (ET)",
 "Nueva carga": "New load",
 "Nueva categoría": "New category",
 "Nueva contraseña": "New password",
 "Nueva contraseña *": "New password *",
 "Nueva ubicación": "New location",
 "Nuevo cliente": "New customer",
 "Nuevo problema: {v0}{v1}": "New problem: {v0}{v1}",
 "Nuevo usuario": "New user",
 "Nítida": "Sharp",
 "OPERACIÓN": "OPERATIONS",
 "Oficina · {v0}": "Office · {v0}",
 "Omitido": "Skipped",
 "Opcional": "Optional",
 "Opcional · sin recibir": "Optional · not received",
 "Otro": "Other",
 "Otro correo": "Another email",
 "Otro lugar (escribirlo)": "Other place (type it)",
 "Otros archivos de las etapas": "Other files from the steps",
 "PANEL DE OPERACIÓN": "OPERATIONS PANEL",
 "PDF, JPG o PNG": "PDF, JPG, or PNG",
 "POD aprobado": "Approved POD",
 "POD con observaciones": "POD with notes",
 "Panel del día": "Daily board",
 "Papeles con observaciones": "Papers with notes",
 "Papeles firmados": "Signed papers",
 "Papeles que la IA marcó con problemas y el chofer subió igual.": "Papers that AI flagged with issues and the driver uploaded anyway.",
 "Para": "To",
 "Para cancelar la carga hay que poner el motivo. Después se puede reactivar.": "To cancel the load, you must enter a reason. It can be reactivated later.",
 "Para cargar una orden: ID de carga, contenedor, tamaño, cliente y las etapas del recorrido, cada una con su lugar, horario y chofer. Se carga una sola vez y cada chofer ve sus etapas en su celular.": "To create a load: Load ID, container, size, customer, and the trip steps, each with its location, time, and driver. It is entered only once, and each driver sees their steps on their phone.",
 "Parada en yarda": "Yard stop",
 "Parada en yarda activada · el chofer carga el espacio al llegar": "Yard stop enabled · the driver enters the spot upon arrival",
 "Parada en yarda opcional · Desactivada para recorrido directo": "Optional Yard stop · Disabled for direct trip",
 "Pedido": "Request",
 "Pedidos de insumos": "Supply requests",
 "Pedidos de insumos pendientes": "Pending supply requests",
 "Pedidos de los choferes y gastos del camión": "Driver requests and truck expenses",
 "Pendiente": "Pending",
 "Pendiente (requerido)": "Pending (required)",
 "Pendiente de aprobación": "Pending approval",
 "Pendientes informados": "Reported pending items",
 "Pendientes informados (hoy)": "Reported pending items (today)",
 "Pensando…": "Thinking…",
 "Período": "Period",
 "Pick up chassis, Rail pickup, Delivery, Return empty container y Return chassis. Cada etapa tiene su lugar, dirección, fecha, horario y chofer. Toca una etapa para abrirla o cerrarla.": "Pick up chassis, Rail pickup, Delivery, Return empty container, and Return chassis. Each step has its location, address, date, time, and driver. Tap a step to open or close it.",
 "Plantilla": "Template",
 "Plantilla — papeles pendientes": "Template — pending papers",
 "Plantilla — recordatorio de turno": "Template — shift reminder",
 "Poner hora de llegada": "Set arrival time",
 "Por chofer, por camión o por estado de EE. UU.": "By driver, truck, or U.S. state",
 "Por estado": "By state",
 "Por estado, por tipo o por chofer.": "By state, type, or driver.",
 "Por reasignar": "To reassign",
 "Por seguridad, define una nueva contraseña para continuar.": "For security, set a new password to continue.",
 "Por {cancelada_por} · {v1}": "By {cancelada_por} · {v1}",
 "Precio/Galón": "Price/Gallon",
 "Pregunta algo, por ejemplo: ¿cómo viene el día?": "Ask something, for example: how's the day looking?",
 "Pregunta sobre cargas, choferes, diésel e insumos": "Ask about loads, drivers, fuel, and supplies",
 "Pregúntale en palabras normales, por ejemplo «¿cómo viene el día?». También arma reportes.": "Ask in plain words, for example «how's the day looking?». It also builds reports.",
 "Pregúntale por cargas, choferes, diésel, incidentes o insumos. Es de solo lectura.": "Ask about loads, drivers, fuel, incidents, or supplies. It's read-only.",
 "Probar y ejecutar": "Test and run",
 "Problema": "Problem",
 "Problema mecánico": "Mechanical problem",
 "Problemas": "Problems",
 "Problemas abiertos": "Open issues",
 "Problemas que reportan los choferes, documentos que un chofer avisó que no pudo subir, cargas por reasignar, pedidos y gastos. El número rojo dice cuántas hay.": "Problems drivers report, documents a driver said they couldn't upload, loads to reassign, requests, and expenses. The red number shows how many there are.",
 "Prueba": "Test",
 "Próximo paso": "Next step",
 "Próximo: {proximo_paso}": "Next: {proximo_paso}",
 "Quitar archivo": "Remove file",
 "Quitar parada en yarda": "Remove yard stop",
 "Quitar {email}": "Remove {email}",
 "Quién recibe los reportes, los avisos de problema y el resumen diario.": "Who receives reports, problem alerts, and the daily summary.",
 "Qué importar": "What to import",
 "Qué tan claro tiene que verse un papel para aprobarlo, de 1 a 5. Lo recomendado es 3.": "How clear a document must look to approve it, from 1 to 5. The recommended setting is 3.",
 "REGISTROS": "RECORDS",
 "Reactivar": "Reactivate",
 "Reactivar carga": "Reactivate load",
 "Real — envía por WhatsApp": "Real — send via WhatsApp",
 "Receiver (quien recibe)": "Receiver (who receives)",
 "Rechazado": "Rejected",
 "Rechazar": "Reject",
 "Rechazar gasto": "Reject expense",
 "Rechazo: {nota}": "Rejection: {nota}",
 "Recibido": "Received",
 "Recibido ({total})": "Received ({total})",
 "Recibo corregido": "Corrected receipt",
 "Recibos": "Receipts",
 "Recibos cargados por los choferes, con lectura automática por IA": "Receipts uploaded by drivers, with automatic AI reading",
 "Recogida": "Pickup",
 "Recorrido": "Route",
 "Referencia": "Reference",
 "Registrado": "Recorded",
 "Registrar chasis y contenedor": "Record chassis and container",
 "Repetir contraseña": "Repeat password",
 "Reporte": "Report",
 "Reporte de diésel del trimestre": "Quarterly fuel report",
 "Reporte generado": "Report generated",
 "Reportes": "Reports",
 "Reportes en PDF por fechas, para descargar o mandar por correo.": "PDF reports by date, to download or send by email.",
 "Reportes generados": "Generated reports",
 "Requiere aprobación": "Requires approval",
 "Resetear": "Reset",
 "Resetear contraseña — {nombre}": "Reset password — {nombre}",
 "Resolver": "Resolve",
 "Resolver incidente — {v0}": "Resolve incident — {v0}",
 "Resultado: {v0}{v1}": "Result: {v0}{v1}",
 "Resultados de búsqueda (todas las fechas)": "Search results (all dates)",
 "Resumen (a mano)": "Summary (manual)",
 "Resumen diario": "Daily summary",
 "Resumen enviado: {v0} · Errores: {v1}": "Summary sent: {v0} · Errors: {v1}",
 "Revisar e importar": "Review and import",
 "Riel": "Rail",
 "Rieles, yardas, depósitos de vacíos y alquiler de chasis.": "Rail, yards, empty depots, and chassis rental.",
 "Rol": "Role",
 "Rol *": "Role *",
 "Salida": "Departure",
 "Salir de la guía": "Exit the guide",
 "Se crearon {creadas} registro(s)": "{creadas} record(s) created",
 "Se usa en el resumen diario y en el aviso de problema.": "Used in the daily summary and the problem notice.",
 "Siguiente": "Next",
 "Simulación — registra el intento, no envía": "Simulation — records the attempt, does not send",
 "Simulado": "Simulated",
 "Sin asignar": "Unassigned",
 "Sin batería": "No battery",
 "Sin carga": "No load",
 "Sin categorías": "No categories",
 "Sin cerrar": "Unclosed",
 "Sin chofer": "No driver",
 "Sin chofer asignado": "No driver assigned",
 "Sin cliente": "No customer",
 "Sin clientes": "No customers",
 "Sin destinatarios": "No recipients",
 "Sin documentos de la oficina.": "No office documents.",
 "Sin envíos todavía": "No shipments yet",
 "Sin lugar": "No place",
 "Sin obstrucción": "No obstruction",
 "Sin registros": "No records",
 "Sin ubicaciones": "No locations",
 "Solo el administrador aprueba o rechaza los gastos.": "Only the administrator approves or rejects expenses.",
 "Sube un archivo .csv o .xlsx para crear choferes, clientes o ubicaciones en lote.": "Upload a .csv or .xlsx file to create drivers, customers, or locations in bulk.",
 "Subido igual: {motivo_subida_forzada}": "Uploaded anyway: {motivo_subida_forzada}",
 "Subir": "Upload",
 "Subir documento": "Upload document",
 "Sí": "Yes",
 "Tamaño": "Size",
 "Tamaño *": "Size *",
 "Tamaño del contenedor": "Container size",
 "Te mostramos para qué sirve cada parte, en un minuto.": "We show you what each part is for in one minute.",
 "Te mostramos para qué sirve cada parte. Avanza con «Siguiente» y sal cuando quieras con la X o la tecla Esc.": "We show you what each part is for. Move forward with «Next» and exit anytime with the X or the Esc key.",
 "Teléfono": "Phone",
 "Teléfono (+1XXXXXXXXXX)": "Phone (+1XXXXXXXXXX)",
 "Teléfono de prueba": "Test phone",
 "Terminada": "Finished",
 "Terminadas": "Finished",
 "Terminar": "Finish",
 "Tipo": "Type",
 "Tipo *": "Type *",
 "Tipo de descarga": "Unload type",
 "Tipo de documento actualizado": "Updated document type",
 "Tipo de reporte": "Report type",
 "Tipo, tamaño y estado operativo: qué está pasando ahora y cuál es el próximo paso. También el cliente, el contenedor asignado y el chofer responsable.": "Type, size, and operating status: what is happening now and what the next step is. Also the customer, assigned container, and responsible driver.",
 "Toca aquí para ver todas las secciones: Alertas, Jornadas, Diésel, Insumos, Agente, Reportes y más.": "Tap here to see all sections: Alerts, Shifts, Fuel, Supplies, Assistant, Reports, and more.",
 "Toca uno para probar.": "Tap one to try it.",
 "Todavía no generaste ningún reporte": "You haven't generated any reports yet",
 "Todavía no hay credenciales de Meta (WHATSAPP_TOKEN / WHATSAPP_PHONE_NUMBER_ID)": "There are no Meta credentials yet (WHATSAPP_TOKEN / WHATSAPP_PHONE_NUMBER_ID)",
 "Todavía no hay módulos para tu perfil.": "There are no modules for your profile yet.",
 "Todo asignado a {v0}": "Everything assigned to {v0}",
 "Todo lo que necesita tu atención, ordenado por tipo. Si no hay nada pendiente, la pantalla queda vacía.": "Everything that needs your attention, sorted by type. If nothing is pending, the screen stays empty.",
 "Todo lo que pasó con la carga, quién lo hizo y a qué hora.": "Everything that happened with the load, who did it, and when.",
 "Todos": "All",
 "Totales": "Totals",
 "Trimestre anterior": "Previous quarter",
 "Tu pregunta": "Your question",
 "Tus reportes": "Your reports",
 "Ubicaciones": "Locations",
 "Ubicación": "Location",
 "Ubicación actual": "Current location",
 "Ubicación actualizada": "Location updated",
 "Ubicación creada": "Location created",
 "Ubicación del catálogo": "Catalog location",
 "Ubicación del riel": "Rail location",
 "Umbral de legibilidad": "Legibility threshold",
 "Un papel se aprueba solo si su legibilidad es mayor o igual a este nivel (1 a 5).": "A document is approved only if its legibility is greater than or equal to this level (1 to 5).",
 "Un pedido es algo que el chofer necesita: márcalo «Entregado» cuando se lo des. Un gasto es algo que compró: los que no son habituales esperan aprobación.": "A request is something the driver needs: mark it «Delivered» when you give it to them. An expense is something they bought: unusual ones wait for approval.",
 "Un usuario para cada chofer, dispatch o persona de mantenimiento. Al chofer cárgale el teléfono (para WhatsApp) y el camión.": "One user for each driver, dispatcher, or maintenance person. For the driver, add the phone number (for WhatsApp) and truck.",
 "Usa el usuario que te dio la oficina.": "Use the username the office gave you.",
 "Usuario": "User",
 "Usuario *": "User *",
 "Usuario actualizado": "User updated",
 "Usuario creado": "User created",
 "Usuarios": "Users",
 "Vacío devuelto": "Empty returned",
 "Ver": "View",
 "Ver foto": "View photo",
 "Ver la guía": "View guide",
 "Ver original": "View original",
 "Verde = información enviada desde la app del chofer": "Green = information sent from the driver app",
 "Volver": "Back",
 "Volver al panel": "Back to dashboard",
 "Ya existe una carga con ese ID de carga": "A load with that Load ID already exists",
 "Ya existe una carga con este ID de carga": "A load with this Load ID already exists",
 "Ya existe una carga con este contenedor (fecha {dupAviso})": "A load with this container already exists (date {dupAviso})",
 "Yarda": "Yard",
 "Yarda propia": "Own yard",
 "Yarda propia (Leona's yard)": "Own yard (Leona's yard)",
 "Zona horaria": "Time zone",
 "Zona horaria del receiver": "Receiver time zone",
 "activó {et}": "activated {et}",
 "asignó a {chofer_nombre} a {et}": "assigned {chofer_nombre} to {et}",
 "asignó un chofer": "assigned a driver",
 "cabecera": "header",
 "calle": "street",
 "cambió": "changed",
 "cambió el estado de {v0} a {v1}{v2}": "changed the status from {v0} to {v1}{v2}",
 "cambió el tipo de {v0} a {v1}": "changed the type from {v0} to {v1}",
 "canceló la carga{v0}": "cancelled the load{v0}",
 "cargó la ETA del delivery: {v0}": "uploaded the ETA of the delivery: {v0}",
 "chofer": "driver",
 "ciudad": "city",
 "corregido": "corrected",
 "creó la carga{v0}": "created the load{v0}",
 "cuerpo": "body",
 "desde {hora}": "from {hora}",
 "dias": "days",
 "dígito verificador": "check digit",
 "editó los datos de la carga": "edited the load details",
 "editó {et}": "edited {et}",
 "el chassis devuelto": "the returned chassis",
 "el espacio {v0}": "spot {v0}",
 "el vacío devuelto": "the returned empty container",
 "empezó el viaje": "started the trip",
 "estado": "status",
 "fecha": "date",
 "hasta {hora}": "until {hora}",
 "hora-desde": "time-from",
 "hora-hasta": "time-until",
 "informó un pendiente: falta {v0} — {v1}{v2}": "reported a pending issue: missing {v0} — {v1}{v2}",
 "instrucciones": "instructions",
 "la descarga terminada": "the unload completed",
 "liberó sus etapas pendientes — motivo: {v0}{v1}{v2}": "released their pending steps — reason: {v0}{v1}{v2}",
 "lugar": "place",
 "no se pudo enviar": "couldn't be sent",
 "nombre": "name",
 "opcional": "optional",
 "otro chofer": "another driver",
 "para el {formatFecha}": "for {formatFecha}",
 "por {v0}": "by {v0}",
 "programó el siguiente tramo con {v0}{v1}{v2}": "scheduled the next leg with {v0}{v1}{v2}",
 "quitó el chofer de la carga": "removed the driver from the load",
 "quitó el chofer de {et}": "removed the driver from {et}",
 "quitó {et}": "removed {et}",
 "reactivó la carga": "reactivated the load",
 "reasignó la carga a otro chofer": "reassigned the load to another driver",
 "reasignó {et} a {chofer_nombre}": "reassigned {et} to {chofer_nombre}",
 "referencia": "reference",
 "registró el chasis {v0}": "recorded the Chassis {v0}",
 "registró el contenedor {contenedor}": "recorded the Container {contenedor}",
 "registró el contenedor {contenedor} (no coincide, esperado {esperado})": "recorded the Container {contenedor} (doesn't match, expected {esperado})",
 "registró su llegada a {et}": "recorded arrival at {et}",
 "registró {v0}": "recorded {v0}",
 "reportó un problema: {v0}": "reported a problem: {v0}",
 "requerido": "required",
 "resolvió el problema{v0}": "resolved the problem{v0}",
 "salió de {et}": "left {et}",
 "sin conexión": "offline",
 "subió el Signed DO / POD{v0}": "uploaded the Signed DO / POD{v0}",
 "subió el documento {v0}{v1}": "uploaded the document {v0}{v1}",
 "subió el papel con observaciones{v0}": "uploaded the paper with notes{v0}",
 "subió un papel firmado": "uploaded a signed paper",
 "subió {v0} en {et}{v2}": "uploaded {v0} at {et}{v2}",
 "tamaño sin definir": "undefined size",
 "terminó el viaje": "finished the trip",
 "ubicacion": "location",
 "un archivo": "a file",
 "un dato": "a piece of data",
 "un documento": "a document",
 "una etapa": "one step",
 "una ubicación": "one location",
 "yarda-propia": "own-yard",
 "zona": "zone",
 "{invalidas} con error": "{invalidas} with error",
 "{lugar} (catálogo)": "{lugar} (catalog)",
 "{nombre} · {n} de {total}": "{nombre} · {n} of {total}",
 "{n} cargas": "{n} loads",
 "{n} choferes en el recorrido": "{n} drivers on the route",
 "{tipo} — {desde} a {hasta}": "{tipo} — {desde} to {hasta}",
 "{titulo} · {n} de {total}": "{titulo} · {n} of {total}",
 "{v0} · cargada a las {v1}{v2}": "{v0} · uploaded at {v1}{v2}",
 "{validas} válidas": "{validas} valid",
 "«{n}»: el ZIP debe tener 5 dígitos": "“{n}”: ZIP must have 5 digits",
 "«{n}»: la hora «hasta» es anterior a la hora «desde»": "“{n}”: the “to” time is earlier than the “from” time",
 "· Enviado a {v0}": "· Sent to {v0}",
 "· papel subido con observaciones": "· paper uploaded with notes",
 "· quedó en {ubicacion}": "· stayed at {ubicacion}",
 "· {chofer_nombre} · Falta {v1} · {v2}": "· {chofer_nombre} · Missing {v1} · {v2}",
 "¿Cuántos contenedores movimos esta semana?": "How many containers did we move this week?",
 "¿Cuántos galones cargó cada chofer este mes?": "How many gallons did each driver load this month?",
 "¿Cómo viene el día?": "How's the day going?",
 "¿Hay problemas abiertos?": "Are there open problems?",
 "¿Primera vez?": "First time?",
 "¿Qué cargas siguen sin asignar hoy?": "Which loads are still unassigned today?",
 "Últimos envíos": "Latest shipments",
 "— motivo: {v0}": "— reason: {v0}",
 "— quedó en {ub}": "— it stayed at {ub}"
};
